import type { StoredEmailDetail } from '@packages/types';
import { Badge } from '../ui/Badge';

interface EmailPreviewProps {
  email: StoredEmailDetail;
}

export function EmailPreview({ email }: EmailPreviewProps) {
  const isSent = email.direction === 'sent';
  const formatAddress = (addr: { name: string | null; email: string }) =>
    addr.name ? `${addr.name} <${addr.email}>` : addr.email;

  return (
    <div className="rounded-lg border border-border bg-bg-subtle p-4">
      <div className="mb-2 flex items-center gap-2">
        <Badge variant={isSent ? 'warning' : 'info'}>
          {isSent ? 'Sent' : 'Received'}
        </Badge>
        <h4 className="text-sm font-semibold text-secondary">
          {email.subject || '(No subject)'}
        </h4>
      </div>
      <div className="space-y-1 text-sm text-text-muted">
        <div>
          <span className="font-medium">From:</span> {formatAddress(email.from)}
        </div>
        <div>
          <span className="font-medium">To:</span>{' '}
          {email.to.map(formatAddress).join(', ')}
        </div>
        <div>
          <span className="font-medium">Date:</span>{' '}
          {new Date(email.date).toLocaleString('en-ZA', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })}
        </div>
      </div>
      {email.snippet && (
        <p className="mt-3 whitespace-pre-wrap border-t border-border pt-3 text-sm text-secondary">
          {email.snippet}
        </p>
      )}
    </div>
  );
}
